export default "__VITE_PUBLIC_ASSET__f32c059d__"